import axios from "axios";

const BASE_URL = "/lmiga/user/trip";

/**
 * Get the current user's account info.
 * Requires alertsLoggedIn cookie.
 *
 * @returns {{ email: string, format: string, emailVerified: boolean, created: string, suspendAlertsPeriod: object }}
 */
export const getAccount = async () => {
  const response = await axios.get(`${BASE_URL}/account.json`);
  return response.data?.data;
};

/**
 * Update account details (email, password, format, suspend period).
 *
 * @param {{ email?: string, password?: string, format?: string, suspendAlertsStart?: string, suspendAlertsEnd?: string }} data
 */
export const updateAccount = async (data) => {
  const response = await axios.put(`${BASE_URL}/account.json`, data);
  return response.data?.data;
};

/**
 * Delete the current user's account.
 */
export const deleteAccount = async () => {
  const response = await axios.delete(`${BASE_URL}/account.json`);
  return response.data;
};

/**
 * Resend the email verification notification.
 */
export const resendVerificationEmail = async () => {
  try {
    const response = await axios.post(`${BASE_URL}/resend-verification.json`);
    return response.data;
  } catch (error) {
    console.error("Error resending verification email:", error);
    throw (
      error.response?.data || { message: "Failed to resend verification email" }
    );
  }
};

/**
 * Logout the current trip user (clears alertsLoggedIn cookie only).
 *
 * Any admin session is left alone, so an admin who used "become user" returns to being just an
 * admin. Full logout is /user/logout.json, which the admin control in the header posts to.
 */
export const logout = async () => {
  const response = await axios.post("/lmiga/user/trip/logout.json");
  return response.data;
};
